var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullscreen = function SvgFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.125 5.5h1.5v4.75h4.75v1.5H.125V5.5Z",
    fill: "#282830"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.971 6.904 1.375 11.5l-1.06-1.06L4.91 5.842l1.06 1.06ZM11.875 6.25h-1.5V1.5h-4.75V0h6.25v6.25Z",
    fill: "#282830"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.029 4.846 10.625.25l1.06 1.06L7.09 5.908l-1.06-1.06Z",
    fill: "#282830"
  })));
};
export default SvgFullscreen;